import { authService } from "../services/authService";

// Mapper les codes d'erreur Firebase → messages lisibles
const firebaseError = (code) => {
  const map = {
    "auth/user-not-found":    "Aucun compte associé à cet email.",
    "auth/wrong-password":    "Mot de passe incorrect.",
    "auth/invalid-email":     "Adresse email invalide.",
    "auth/email-already-in-use": "Cet email est déjà utilisé.",
    "auth/too-many-requests": "Trop de tentatives. Réessayez plus tard.",
    "auth/network-request-failed": "Problème réseau. Vérifiez votre connexion.",
  };
  return map[code] || "Une erreur est survenue.";
};

const handleError = (err) => ({
  success: false,
  type:    err?.type || "UNKNOWN",
  message: err?.type === "VALIDATION" || err?.type === "EMAIL_NOT_VERIFIED"
    ? err.message
    : firebaseError(err?.code),
});

export const authController = {

  login: async (email, password) => {
    try {
      const { user, role } = await authService.login(email, password);
      return { success: true, data: { user, role } };
    } catch (err) { return handleError(err); }
  },

  register: async (email, password, displayName) => {
    try {
      const { user } = await authService.register(email, password, displayName);
      return { success: true, data: { user } };
    } catch (err) { return handleError(err); }
  },

  logout: async () => {
    try {
      await authService.logout();
      return { success: true };
    } catch (err) { return handleError(err); }
  },

  resetPassword: async (email) => {
    try {
      await authService.resetPassword(email);
      return { success: true };
    } catch (err) { return handleError(err); }
  },
};